import { useEffect, useRef } from 'react';

export default function useClickOutside(onClickOutside: () => any): React.Ref<any> {
  const ref = useRef();

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const handleEvent = (e) => {
      if (ref && ref.current) {
        // @ts-ignore
        if (!ref.current.contains(e.target)) {
          onClickOutside();
        }
      }
    };

    if (window.PointerEvent) {
      document.addEventListener('pointerdown', handleEvent);
    } else {
      document.addEventListener('mousedown', handleEvent);
      document.addEventListener('touchstart', handleEvent);
    }

    return () => {
      if (window.PointerEvent) {
        document.removeEventListener('pointerdown', handleEvent);
      } else {
        document.removeEventListener('mousedown', handleEvent);
        document.removeEventListener('touchstart', handleEvent);
      }
    };
  }, [typeof window, onClickOutside]);

  return ref;
}
